<template>
  <div class="tabContent">
    <!-- <vxe-toolbar v-show="isEdit">
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="handleDelete('goodsTable')"
        >{{$t('salesBill.batchMatchingResults.button.del')}}</vxe-button>
      </template>
    </vxe-toolbar> -->
    <vxe-table
      border
      show-overflow
      auto-resize
      resizable
      :data="storageLadingPicking"
      :edit-config="editConfig"
      :edit-rules="goodsTableRules"
      size="mini"
      ref="goodsTable"
      :valid-config="{ autoPos: true, message: 'inline' }"
      keep-source
      :max-height="$store.state.app.tableHeight"
      @edit-actived="editActivedEvent"
    >
      <!-- <vxe-table-column type="checkbox" width="60" fixed="left"></vxe-table-column> -->
      <vxe-table-column
        type="seq"
        width="60"
        :title="this.$t('salesBill.batchMatchingResults.table.seq')"
      ></vxe-table-column>
      <vxe-table-column
        field="carNo"
        :title="this.$t('salesBill.batchMatchingResults.table.carNo')"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            v-model="scope.row.carNo"
            @input="$refs.goodsTable.updateStatus(scope)"
            :disabled="rowDisabled"
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column field="productDesc" title="商品描述" width="140"></vxe-table-column>
      <vxe-table-column
        field="netWeight"
        :title="this.$t('salesBill.batchMatchingResults.table.netWeight')"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number
            :max="99999999999.9999"
            v-model="scope.row.netWeight"
            :clearable="true"
            :precision="$globalVar.qPoint"
            :disabled="rowDisabled"
          ></input-number>
        </template>
        <template v-slot="scope">
          {{
            replaceLastZeroStr(
              $baseRequest.formatTableColumn(scope.row.netWeight, $globalVar.qPoint)
            )
          }}
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="deduct"
        :title="this.$t('salesBill.batchMatchingResults.table.deduct')"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number
            :max="99999999999.9999"
            v-model="scope.row.deduct"
            :clearable="true"
            :precision="$globalVar.qPoint"
            :disabled="rowDisabled"
          ></input-number>
        </template>
        <template v-slot="scope">
          {{
            replaceLastZeroStr($baseRequest.formatTableColumn(scope.row.deduct, $globalVar.qPoint))
          }}
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="businessChangingUnitPrice"
        :title="this.$t('salesBill.batchMatchingResults.table.businessChangingUnitPrice')"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.businessChangingUnitPrice"
            @change="(val) => changeSelect(val, scope, scope.row)"
            @focus="(val) => getPriceList(scope.row)"
            clearable
            filterable
            :disabled="basicData.ladingStatus == 'TDZT03' || rowDisabled"
          >
            <el-option-group :key="1" :label="'变动价格 可定价数量 定价时间'">
              <el-option
                v-for="item in scope.row.priceOptions"
                :key="item.id"
                :label="item.temporaryPrice"
                :value="item.priceFlag"
              >
                <span style="float: left">
                  {{ item.temporaryPrice }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {{
                    item?.availableLadingQuantity
                  }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {{ item.confirmDate }}
                </span>
              </el-option>
            </el-option-group>
          </el-select>
        </template>
        <template v-slot="scope">
          <div v-if="basicData.exchangeRate == 1">
            {{
              replaceLastZeroStr(
                scope.row.businessChangingUnitPrice
                  ? $baseRequest.formatTableColumn(
                      scope.row.businessChangingUnitPrice,
                      $globalVar.pPoint
                    )
                  : scope.row.businessChangingUnitPrice === 0
                  ? 0
                  : null
              )
            }}
          </div>
          <div v-else>
            <p class="break-space" v-if="scope.row.businessChangingUnitPrice">
              {{
                replaceLastZeroStr(
                  scope.row.businessChangingUnitPrice
                    ? $t('contractAgency.productTab.originCoin')
                    : null
                )
              }}
              {{
                replaceLastZeroStr(
                  $baseRequest.formatTableColumn(
                    scope.row.businessChangingUnitPrice,
                    $globalVar.pPoint
                  )
                )
              }}
            </p>
            <p class="break-space" v-if="scope.row['businessChangingUnitPriceOther']">
              {{
                replaceLastZeroStr(
                  scope.row['businessChangingUnitPriceOther']
                    ? $t('contractAgency.productTab.localCoin')
                    : null
                )
              }}
              {{
                replaceLastZeroStr(
                  $baseRequest.formatTableColumn(
                    scope.row['businessChangingUnitPriceOther'],
                    $globalVar.pPoint
                  )
                )
              }}
            </p>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="ladingQuantity"
        :title="this.$t('salesBill.batchMatchingResults.table.ladingQuantity')"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number
            :max="99999999999.9999"
            v-model="scope.row.ladingQuantity"
            @input="(val) => changeList(val, scope.row, scope)"
            @change="(val) => ladingQuantityChange(val, scope.row, scope)"
            :disabled="actualSendQuantityStatus || rowDisabled"
            :clearable="true"
            :precision="$globalVar.qPoint"
          ></input-number>
        </template>
        <template v-slot="scope">
          {{
            replaceLastZeroStr(
              $baseRequest.formatTableColumn(scope.row.ladingQuantity, $globalVar.qPoint)
            )
          }}
        </template>
      </vxe-table-column>
      <vxe-table-column field="businessLadingAmount" title="提单金额" width="140">
        <template v-slot="scope">
          <div v-if="basicData.exchangeRate == 1">
            {{
              $baseRequest.formatTableColumn(
                replaceZeroStr(scope.row.businessLadingAmount),
                $globalVar.aPoint
              )
            }}
          </div>
          <div v-else>
            <p class="break-space" v-if="scope.row.businessLadingAmount">
              {{
                replaceZeroStr(
                  scope.row.businessLadingAmount ? $t('contractAgency.productTab.originCoin') : null
                )
              }}
              {{
                $baseRequest.formatTableColumn(
                  replaceZeroStr(scope.row.businessLadingAmount),
                  $globalVar.aPoint
                )
              }}
            </p>
            <p class="break-space" v-if="scope.row['businessLadingAmountOther']">
              {{
                replaceZeroStr(
                  scope.row['businessLadingAmountOther']
                    ? $t('contractAgency.productTab.localCoin')
                    : null
                )
              }}
              {{
                $baseRequest.formatTableColumn(
                  replaceZeroStr(scope.row['businessLadingAmountOther']),
                  $globalVar.aPoint
                )
              }}
            </p>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="contractDetailNo"
        :title="this.$t('salesBill.batchMatchingResults.table.contractDetailNo')"
        width="60"
      ></vxe-table-column>
      <vxe-table-column
        field="isDeleted"
        v-show="isEdit"
        :title="this.$t('salesBill.batchMatchingResults.table.action')"
        width="120"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot="scope">
          <vxe-button
            type="primary"
            :class="scope.row.isDeleted == 1 ? 'vxe-btn-primary' : 'vxe-btn-delete'"
            @click="editEvent(scope.row, scope)"
            >{{
              scope.row.isDeleted == 1
                ? $t('salesBill.batchMatchingResults.table.cancelDelete')
                : $t('salesBill.batchMatchingResults.table.delete')
            }}</vxe-button
          >
        </template>
        <template v-slot:edit="scope">
          <vxe-button
            type="primary"
            :class="scope.row.isDeleted == 1 ? 'vxe-btn-primary' : 'vxe-btn-delete'"
            @click="editEvent(scope.row, scope)"
            >{{
              scope.row.isDeleted == 1
                ? $t('salesBill.batchMatchingResults.table.cancelDelete')
                : $t('salesBill.batchMatchingResults.table.delete')
            }}</vxe-button
          >
        </template>
      </vxe-table-column>
      <vxe-table-column field="availableQuantity" title="可提数量" width="80">
        <template v-slot="scope">
          {{
            replaceLastZeroStr(
              $baseRequest.formatTableColumn(scope.row.availableQuantity, $globalVar.qPoint)
            )
          }}
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="ladingUnitName"
        :title="this.$t('salesBill.batchMatchingResults.table.ladingUnitName')"
        width="100"
      ></vxe-table-column>
      <vxe-table-column
        field="salesQuantity"
        :title="this.$t('salesBill.batchMatchingResults.table.salesQuantity')"
        width="80"
      >
        <template v-slot="scope">
          {{
            replaceLastZeroStr(
              $baseRequest.formatTableColumn(scope.row.salesQuantity, $globalVar.qPoint)
            )
          }}
        </template>
      </vxe-table-column>

      <vxe-table-column
        field="actualSendQuantity"
        :title="this.$t('salesBill.batchMatchingResults.table.invoiceDate')"
        width="140"
      >
        <template v-slot="scope">
          {{
            replaceLastZeroStr(
              $baseRequest.formatTableColumn(scope.row.actualSendQuantity, $globalVar.qPoint)
            )
          }}
        </template>
        <!-- <template v-slot:edit="scope">
          <input-number
            v-if="actualSendQuantityStatus"
            max="99999999999.999999"
            :precision="0"
            v-model="scope.row.actualSendQuantity"
            :clearable="true"
          ></input-number>
          <template v-else>
             {{scope.row.actualSendQuantity}}
          </template>
        </template> -->
      </vxe-table-column>
      <!-- <vxe-table-column
          field="customerReceiveQuantity"
          :title="this.$t('salesBill.batchMatchingResults.table.customerReceiveQuantity')"
          width="140"
          :edit-render="{type: 'default'}"
        >
          <template v-slot="scope">
            {{$baseRequest.formatTableColumn(scope.row.customerReceiveQuantity,$globalVar.qPoint)}}
          </template>
        </vxe-table-column> -->

      <vxe-table-column
        field="businessContractUnitPrice"
        :title="this.$t('salesBill.batchMatchingResults.table.businessContractUnitPrice')"
        width="140"
      >
        <template v-slot="scope">
          <div v-if="basicData.exchangeRate == 1">
            {{
              replaceLastZeroStr(
                $baseRequest.formatTableColumn(
                  scope.row.businessContractUnitPrice,
                  $globalVar.pPoint
                )
              )
            }}
          </div>
          <div v-else>
            <p class="break-space" v-if="scope.row.businessContractUnitPrice">
              {{
                replaceLastZeroStr(
                  scope.row.businessContractUnitPrice
                    ? $t('contractAgency.productTab.originCoin')
                    : null
                )
              }}
              {{
                replaceLastZeroStr(
                  $baseRequest.formatTableColumn(
                    scope.row.businessContractUnitPrice,
                    $globalVar.pPoint
                  )
                )
              }}
            </p>
            <p class="break-space" v-if="scope.row['businessContractUnitPriceOther']">
              {{
                replaceLastZeroStr(
                  scope.row['businessContractUnitPriceOther']
                    ? $t('contractAgency.productTab.localCoin')
                    : null
                )
              }}
              {{
                replaceLastZeroStr(
                  $baseRequest.formatTableColumn(
                    scope.row['businessContractUnitPriceOther'],
                    $globalVar.pPoint
                  )
                )
              }}
            </p>
          </div>
        </template>
      </vxe-table-column>

      <!-- <vxe-table-column field="settleBatchNoV2" title="结算批次号" width="140"></vxe-table-column> -->
      <vxe-table-column
        field="shipComplete"
        width="160"
        :title="this.$t('transportDeliveryOrder.form.good.shipComplete')"
      >
        <template v-slot="{ row }">
          <span>{{ row.shipComplete == 'Y' ? '是' : '否' }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="taxRate" width="160" :title="this.$t('税率')">
        <template v-slot="{ row }">
          <span>{{ row.taxRate }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div style="margin-top: 10px">
      <el-form ref="ruleForm" :model="basicData" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              :label="this.$t('salesBill.productDetails.label.businessLadingTotalAmount')"
              prop="businessLadingTotalAmount"
            >
              <el-input v-model="basicData.businessLadingTotalAmount" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-input v-model="basicData.ladingTotalAmountDesc" disabled></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              :label="this.$t('salesBill.productDetails.label.ladingTotalQuantity')"
              prop="ladingTotalQuantity"
            >
              <el-input v-model="basicData.ladingTotalQuantity" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-input v-model="basicData.ladingTotalQuantityDesc" disabled></el-input>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="实发总数量" prop="actualSendQuantityTotal">
              <el-input v-model="basicData.actualSendQuantityTotal" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-input v-model="basicData.actualSendQuantityTotalDesc" disabled></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="实发总金额" prop="actualSendAmountTotal">
              <el-input v-model="basicData.actualSendAmountTotal" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-input v-model="basicData.actualSendAmountTotalDesc" disabled></el-input>
          </el-col>
        </el-row> -->
      </el-form>
    </div>
  </div>
</template>

<script>
  import inputNumber from '@/components/form-item/input-number';
  import { toFixedNumber } from '@/common/js/util';
  import API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill.js';
  export default {
    props: {
      storageLadingPickings: {
        type: Array,
        default: () => [],
      },
      isEdit: {
        type: Boolean,
        default: () => true,
      },
      basicData: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      inputNumber,
    },
    watch: {
      storageLadingPickings() {
        this.storageLadingPicking = JSON.parse(JSON.stringify(this.storageLadingPickings));
      },
    },
    data() {
      return {
        feeFormRules: {},
        tableToolbar: {},
        editConfig: {},
        storageLadingPicking: null,
        actualSendQuantityStatus: false, //实发数量能否编辑
        priceOptions: [], //变动单价
        rowDisabled: false, //行是否可编辑
      };
    },
    computed: {
      goodsTableRules() {
        return {
          ladingQuantity: [
            {
              required: true,
              message: this.$t('salesBill.baseInfo.label.pleaseChooseWrite'),
              trigger: ['change', 'blur'],
            },
          ],
          businessChangingUnitPrice: [
            {
              required: true,
              message: this.$t('salesBill.message.businessChangingUnitPriceMsg'),
              trigger: ['change', 'blur'],
            },
          ],
          carNo: [
            {
              required: true,
              message: this.$t('salesBill.message.carNoMsg'),
              trigger: ['change', 'blur'],
            },
          ],
          netWeight: [
            {
              required: true,
              message: this.$t('salesBill.message.netWeightMsg'),
              trigger: ['change', 'blur'],
            },
          ],
          deduct: [
            {
              required: true,
              message: this.$t('salesBill.message.deductMsg'),
              trigger: ['change', 'blur'],
            },
          ],
        };
      },
    },
    created() {
      this.feeFormRules = {};
    },
    mounted() {
      //审批完成可编辑：直拨类型的提单-实发数量要能编辑
      //修改  只有拣配结果中实发数量和实收数量可编辑
      const deliveryMethod = ['JHFS04', 'JHFS05', 'JHFS06'];
      let deleveryFlag = false;
      if (deliveryMethod.includes(this.basicData.deliveryMethod)) {
        deleveryFlag = true;
      }
      this.$emit('getDeleveryFlag', deleveryFlag);
      this.actualSendQuantityStatus =
        this.basicData.ladingStatus == 'TDZT03' && deleveryFlag ? true : false;
      this.editConfig = this.isEdit ? { trigger: 'click', mode: 'row' } : {};
      this.$nextTick(() => {
        this.storageLadingPicking = JSON.parse(JSON.stringify(this.storageLadingPickings));
        this.upDataOption();
      });
    },
    methods: {
      toFixedNumber,
      //删除之后，拣配结果清空，该条记录不可拣配，提单数量清零
      editEvent(row, scope) {
        row.isDeleted = row.isDeleted == 1 ? 0 : 1;
        row.ladingQuantity = 0;
        row.carNo = !row.carNo ? (row.isDeleted == 1 ? ' ' : null) : row.carNo;
        row.netWeight = !row.netWeight ? (row.isDeleted == 1 ? 0 : null) : row.netWeight;
        row.deduct = !row.deduct ? (row.isDeleted == 1 ? 0 : null) : row.deduct;
        this.storageLadingPicking.forEach((item) => {
          if (item.contractDetailNo == row.contractDetailNo) {
            item.isDeleted = row.isDeleted;
            item.ladingQuantity = 0;
            item.businessChangingUnitPrice = !item.businessChangingUnitPrice
              ? row.isDeleted == 1
                ? 0
                : null
              : item.businessChangingUnitPrice;
            item.carNo = !item.carNo ? (row.isDeleted == 1 ? ' ' : null) : item.carNo;
            item.netWeight = !item.netWeight ? (row.isDeleted == 1 ? 0 : null) : item.netWeight;
            item.deduct = !item.deduct ? (row.isDeleted == 1 ? 0 : null) : item.deduct;
          }
        });
        this.$emit('refreshData', this.storageLadingPicking);
        this.$refs.goodsTable.reloadRow(row);
        this.$refs.goodsTable.updateStatus(scope);
        this.$emit('ladingQuantityChange', row.isDeleted, row, scope, this.storageLadingPicking);
      },
      editActivedEvent({ row }) {
        this.rowDisabled = row.isDeleted == 1;
      },
      //变动单价
      changeSelect(val, scope) {
        if (val || val == 0) {
          scope.row.priceFlag = val;
          let obj = scope.row.priceOptions.find((item) => {
            return item.priceFlag == val;
          });
          scope.row.businessChangingUnitPrice = obj.temporaryPrice;
          scope.row.pricingId = obj.id;
          scope.row.maxQuantity = obj?.availableLadingQuantity;
          if (Number(scope.row.maxQuantity) < Number(scope.row.ladingQuantity)) {
            scope.row.ladingQuantity = JSON.parse(JSON.stringify(scope.row.maxQuantity));
            this.ladingQuantityChange(scope.row.ladingQuantity, scope.row, scope);
          }
        } else {
          scope.row.priceFlag = '';
          scope.row.pricingId = '';
          scope.row.maxQuantity = scope.row.availableQuantity;
          scope.row.businessChangingUnitPrice = '';
          scope.row.temporaryPrice = null;
        }
        this.$refs.goodsTable.updateStatus();
        // this.$refs.goodsTable.reloadRow(scope.row);
        this.$emit('calcQuantityChange', val, scope.row, scope, this.storageLadingPicking);
        this.$emit('refreshData', this.storageLadingPicking);
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getCheckboxRecords(); // 获取选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.notSelectedDelete'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('salesBill.message.delSuccess'),
            });
            this.$refs.goodsTable.updateStatus();

            this.storageLadingPicking = this.$refs.goodsTable.getTableData().fullData;
            // this.storageLadingPicking.forEach((item,index)=>{
            //   item.ladingDetailNo=index+1
            // })
            //this.storageLadingPicking = []
            //this.storageLadingPicking = storageLadingPicking;
            this.$emit('goodsTableChange', this.storageLadingPicking);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('salesBill.message.cancelledDelete'),
            });
          });
      },
      //数据重组
      upDataOption() {
        this.storageLadingPicking.forEach((item) => {
          //  if(!item.customerReceiveQuantity){
          //    this.$set(item, 'customerReceiveQuantity', 0)
          //   }
          //   if(!item.customerReceiveQuantity){
          //    this.$set(item, 'actualSendQuantity', 0)
          //   }
          //   if(this.basicData.deliveryMethod == 'JHFS04' ||this.basicData.deliveryMethod == 'JHFS05' ||this.basicData.deliveryMethod == 'JHFS06'){
          //    this.$set(item, 'nonInvoiceQuantity', item.customerReceiveQuantity)
          //   }else{
          //     this.$set(item, 'nonInvoiceQuantity', 0)
          //   }
          this.getPriceList(item);
        });
        this.$refs.goodsTable.updateStatus();
      },
      //变动单价
      async getPriceList(row) {
        let obj = {
          contractDetailNo: row.contractDetailNo,
          contractNo: row.contractNo,
          currency: this.basicData.ladingCurrency,
        };
        if (this.$route.query.ladingNo) {
          obj.ladingNo = this.$route.query.ladingNo;
        }
        const res = await this.$axios.post(API.GET_PRICE_LIST, obj);
        if (res.data.code == 0) {
          this.$set(row, 'priceOptions', res.data.data);
          row.maxQuantity = row.availableQuantity;
          // if(row.businessChangingUnitPrice){
          //   row.maxQuantity= res.data.data.find(item=>{ return item.temporaryPrice==row.businessChangingUnitPrice}).availableLadingQuantity
          // }
          if (row.priceFlag) {
            row.maxQuantity = res.data.data.find((item) => {
              return item.priceFlag == row.priceFlag;
            })?.availableLadingQuantity;
          }
        }
      },
      //校验
      validateAll() {
        //const errMap = await this.$refs.goodsTable.validate().catch(errMap => errMap);
        return new Promise((resolve, reject) => {
          this.$refs.goodsTable.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              this.$message.error('请补充商品明细');
              reject();
            }
          });
        });
      },
      //提单数量发生变化 判断是否已经拣配 如果已拣配 则清空该商品明细下的拣配结果
      ladingQuantityChange(val, row, scope) {
        this.$refs.goodsTable.reloadRow(row);
        this.$refs.goodsTable.updateStatus(scope);
        this.$emit('ladingQuantityChange', val, row, scope, this.storageLadingPicking);
      },
      changeList(val, row, scope) {
        row.ladingQuantity = val;
        row.actualSendQuantity = val;
        // row.businessLadingAmount = row.businessContractUnitPrice*Number(val);
        this.$refs.goodsTable.updateStatus(scope);
        // let parent = this.$refs.goodsTable.$parent.basicData

        // let ladingTotalQuantity = 0;
        // let businessLadingTotalAmount = 0;
        // this.storageLadingPicking.forEach(item=>{
        //   if(!item.ladingQuantity){
        //     item.ladingQuantity = 0;
        //   }else{
        //     ladingTotalQuantity+= Number(item.ladingQuantity);
        //   }
        //   if(!item.ladingQuantity){
        //     item.ladingQuantity = 0;
        //   }else{
        //      businessLadingTotalAmount+= Number(item.businessLadingAmount);
        //   }
        // })
        // //更新提单总额
        // parent.ladingTotalQuantity = ladingTotalQuantity;
        // parent.ladingTotalQuantityDesc = toUpperCase(ladingTotalQuantity);
        // parent.businessLadingTotalAmount = businessLadingTotalAmount;
        // if(parent.ladingCurrency=="CNY"){
        //  parent.ladingTotalAmountDesc = digitUppercase(businessLadingTotalAmount);
        // }else{
        //  parent.ladingTotalAmountDesc=""
        // }
      },
      deliveryExpenseUnitPriceChange(val, row, scope) {
        this.$emit('calcQuantityChange', val, scope.row, scope, this.storageLadingPicking);
        this.$refs.goodsTable.reloadRow(row);
        this.$refs.goodsTable.updateStatus(scope);
        this.$emit('refreshData', this.storageLadingPicking);
      },
      refreshPage(obj) {
        console.log(obj, '---------------------111-------------------------------------------');
        this.storageLadingPicking = JSON.parse(JSON.stringify(obj));
      },
      //抛出表格数据
      exportTableData() {
        let storageLadingPickingList = this.storageLadingPicking;
        return storageLadingPickingList;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .inputWidth {
    width: 100% !important;
  }
  .tabContent {
    padding: 10px;
    background-color: #fff;
  }
  .break-space {
    white-space: nowrap;
    line-height: 18px;
  }
  // .el-select-dropdown__empty{
  //   display: none;
  // }
</style>
